import { Component } from '@angular/core';
import { HelpersService } from '../../services/helpers/helpers.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
    selector: 'litmus-alert',
    templateUrl: './litmus-alert.component.html',
    styleUrl: './litmus-alert.component.scss',
    standalone: false
})
export class LitmusAlertComponent {
  showModel:boolean = false;
  title:any = ''
  content:any= ''
  description:string= ''
  callback:any = null; 
  buttons:any = [{
    text:"No",
    type:'secondary',
    key:'No'
  },{
    text:"Yes",
    type:'primary',
    key:'Yes'
  }];
  constructor(private _helpers:HelpersService,private _domSanitizer:DomSanitizer){
    this._helpers.messageBox.subscribe((data:any)=>{

      let titleHTML = (data.title)?data.title:'';
      let contentHTML = (data.content)?data.content:'';
      /**
       * Modified By : Hitesh Sharma
       * Modified Date : 08/05/2026
       * Modified Reason : To resolve the page hang/stuck issue
       */
      // this.title = (data.title)?data.title:'';
      // this.content = (data.content)?data.content:'';
      this.title = this._domSanitizer.bypassSecurityTrustHtml(titleHTML);
      this.content = this._domSanitizer.bypassSecurityTrustHtml(contentHTML);
      this.description = (data.description)?data.description:'';
      this.buttons = (data.buttons && data.buttons.length)?data.buttons:[{
        text:"No",
        type:'secondary',
        key:'No'
      },{
        text:"Yes",
        type:'primary',
        key:'Yes'
      }]

      this.callback = (data.cb)?data.cb:null;
      this.showModel = true
    })
  }

  cancel(){
    this.showModel = false;
    this.callback('No')
  }

  confirm(){
    this.showModel = false;
    this.callback('Yes')
  }
  onClick(value:any){
    this.showModel = false;
    this.callback(value)
  }

  // Modified By : Hitesh Sharma due To resolve the page hang/stuck issue
  // getSafeHTML(html:any){
  //   return this._domSanitizer.bypassSecurityTrustHtml(html)
  // }


}
